export default {
  CREATE_JOB: 'CREATE_JOB',
  VIEW_JOB: 'VIEW_JOB',
  UPDATE_JOB: 'UPDATE_JOB',
  CREATE_FUEL: 'CREATE_FUEL',
  VIEW_FUEL: 'VIEW_FUEL',
  UPDATE_FUEL: 'UPDATE_FUEL',
  RECORD_FILLING_FUEL: 'RECORD_FILLING_FUEL',
  ATTACH_BILL_FUEL: 'ATTACH_BILL_FUEL',
  PRINT_FUEL: 'PRINT_FUEL',
  CREATE_CLIENT: 'CREATE_CLIENT',
  VIEW_CLIENT: 'VIEW_CLIENT',
  UPDATE_CLIENT: 'UPDATE_CLIENT',
  CREATE_INVOICE: 'CREATE_INVOICE',
  VIEW_INVOICE: 'VIEW_INVOICE',
  UPDATE_INVOICE: 'UPDATE_INVOICE',
  PRINT_INVOICE: 'PRINT_INVOICE',
  RECEIVE_PAYMENT_INVOICE: 'RECEIVE_PAYMENT_INVOICE',
  EXPORT_INVOICE: 'EXPORT_INVOICE',
  CREATE_BILL: 'CREATE_BILL',
  VIEW_BILL: 'VIEW_BILL',
  UPDATE_BILL: 'UPDATE_BILL',
  PRINT_BILL: 'PRINT_BILL',
  RECEIVE_PAYMENT_BILL: 'RECEIVE_PAYMENT_BILL',
  EXPORT_BILL: 'EXPORT_BILL',
  CREATE_SHIPPING_ORDER: 'CREATE_SHIPPING-ORDER',
  VIEW_SHIPPING_ORDER: 'VIEW_SHIPPING-ORDER',
  UPDATE_SHIPPING_ORDER: 'UPDATE_SHIPPING-ORDER',
  ASSIGN_SHIPPING_ORDER: 'ASSIGN_SHIPPING-ORDER',
  RECORD_DELIVERY_SHIPPING_ORDER: 'RECORD_DELIVERY_SHIPPING-ORDER',
  CREATE_INVOICE_SHIPPING_ORDER: 'CREATE_INVOICE_SHIPPING-ORDER',
  EXPORT_SHIPPING_ORDER: 'EXPORT_SHIPPING-ORDER',
  CREATE_TRUCK: 'CREATE_TRUCK',
  VIEW_TRUCK: 'VIEW_TRUCK',
  UPDATE_TRUCK: 'UPDATE_TRUCK',
  EXPORT_TRUCK: 'EXPORT_TRUCK',
  CREATE_DRIVER: 'CREATE_DRIVER',
  VIEW_DRIVER: 'VIEW_DRIVER',
  UPDATE_DRIVER: 'UPDATE_DRIVER',
  EXPORT_DRIVER: 'EXPORT_DRIVER',
  VIEW_USER: 'VIEW_USER',
  UPDATE_USER: 'UPDATE_USER',
  CREATE_GAS_STATION: 'CREATE_GAS-STATION',
  VIEW_GAS_STATION: 'VIEW_GAS-STATION',
  UPDATE_GAS_STATION: 'UPDATE_GAS-STATION',
  EXPORT_GAS_STATION: 'EXPORT_GAS-STATION',
  CREATE_MECHANIC: 'CREATE_MECHANIC',
  VIEW_MECHANIC: 'VIEW_MECHANIC',
  UPDATE_MECHANIC: 'UPDATE_MECHANIC',
  VIEW_ROLE: 'VIEW_ROLE',
  UPDATE_ROLE: 'UPDATE_ROLE',
  CREATE_STARTPOINT: 'CREATE_STARTPOINT',
  UPDATE_STARTPOINT: 'UPDATE_STARTPOINT',
  VIEW_STARTPOINT: 'VIEW_STARTPOINT',
  CREATE_DESTINATION: 'CREATE_DESTINATION',
  UPDATE_DESTINATION: 'UPDATE_DESTINATION',
  VIEW_DESTINATION: 'VIEW_DESTINATION',
  VIEW_LOGS: 'VIEW_LOGS',
  VIEW_EXPENSE: 'VIEW_EXPENSE',
  VIEW_DASHBOARD: 'VIEW_DASHBOARD',
  CREATE_GARAGE: 'CREATE_GARAGE',
  VIEW_GARAGE: 'VIEW_GARAGE',
  UPDATE_GARAGE: 'UPDATE_GARAGE',
  CREATE_REPAIR: 'CREATE_REPAIR',
  UPDATE_REPAIR: 'UPDATE_REPAIR',
  VIEW_REPAIR: 'VIEW_REPAIR',
  CREATE_INVENTORY: 'CREATE_INVENTORY',
  UPDATE_INVENTORY: 'UPDATE_INVENTORY',
  VIEW_INVENTORY: 'VIEW_INVENTORY',
  CREATE_TIRE_INVENTORY: 'CREATE_TIRE',
  UPDATE_TIRE_INVENTORY: 'UPDATE_TIRE',
  VIEW_TIRE_INVENTORY: 'VIEW_TIRE',
  CREATE_PURCHASE_ORDER: 'CREATE_PURCHASEORDER',
  UPDATE_PURCHASE_ORDER: 'UPDATE_PURCHASEORDER',
  VIEW_PURCHASE_ORDER: 'VIEW_PURCHASEORDER',
  CREATE_SUPPLIER: 'CREATE_SUPPLIER',
  UPDATE_SUPPLIER: 'UPDATE_SUPPLIER',
  VIEW_SUPPLIER: 'VIEW_SUPPLIER',
  CREATE_WAREHOUSE: 'CREATE_WAREHOUSE',
  UPDATE_WAREHOUSE: 'UPDATE_WAREHOUSE',
  VIEW_WAREHOUSE: 'VIEW_WAREHOUSE',
  CREATE_PURCHASE_REQUISITION: 'CREATE_PURCHASEREQUEST',
  UPDATE_PURCHASE_REQUISITION: 'UPDATE_PURCHASEREQUEST',
  VIEW_PURCHASE_REQUISITION: 'VIEW_PURCHASEREQUEST',
  CREATE_TIRE_PATCH: 'CREATE_TIREPATCHLOG',
  UPDATE_TIRE_PATCH: 'UPDATE_TIREPATCHLOG',
  VIEW_TIRE_PATCH: 'VIEW_TIREPATCHLOG',
  CREATE_GOOD_RECEIVED: 'CREATE_GOODRECEIVE',
  UPDATE_GOOD_RECEIVED: 'UPDATE_GOODRECEIVE',
  VIEW_GOOD_RECEIVED: 'VIEW_GOODRECEIVE',
  CREATE_TIRE_GOOD_RECEIVED: 'CREATE_GOODRECEIVETIRE',
  UPDATE_TIRE_GOOD_RECEIVED: 'UPDATE_GOODRECEIVETIRE',
  VIEW_TIRE_GOOD_RECEIVED: 'VIEW_GOODRECEIVETIRE',
  CREATE_SALARY: 'CREATE_SALARY',
  UPDATE_SALARY: 'UPDATE_SALARY',
  VIEW_SALARY: 'VIEW_SALARY',
  CREATE_TIREPATCHSTORE: 'CREATE_TIREPATCHSTORE',
  VIEW_TIREPATCHSTORE: 'VIEW_TIREPATCHSTORE',
  UPDATE_TIREPATCHSTORE: 'UPDATE_TIREPATCHSTORE',
  ACTIVATE_GAS_STATION: 'ACTIVATE_GAS-STATION',
  VIEW_FUELCOSTSUMMARY: 'VIEW_FUELCOSTSUMMARY',
  IMPORT_FUELCOSTSUMMARY: 'IMPORT_FUELCOSTSUMMARY',
  CREATE_SHIPPING_ORDER_OVER_LIMIT: 'CREATE_SHIPPING_ORDER_OVER_LIMIT',
  CREATE_OVER_LIMIT: 'CREATE_OVER_LIMIT',
  CREATE_FUEL_ORDER_OVER_LIMIT: 'CREATE_FUEL_ORDER_OVER_LIMIT',
}
